import { MagicIncomingWindowMessage } from '@magic-sdk/types';
var ViewController = /** @class */ (function () {
    function ViewController(transport, endpoint, encodedQueryParams) {
        this.transport = transport;
        this.endpoint = endpoint;
        this.encodedQueryParams = encodedQueryParams;
        this.ready = this.waitForReady();
        if (this.init)
            this.init();
        this.listen();
    }
    ViewController.prototype.waitForReady = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.transport.on(MagicIncomingWindowMessage.MAGIC_OVERLAY_READY, function () { return resolve(); });
        });
    };
    /**
     * Listen for messages sent from the underlying Magic `<WebView>`.
     */
    ViewController.prototype.listen = function () {
        var _this = this;
        this.transport.on(MagicIncomingWindowMessage.MAGIC_HIDE_OVERLAY, function () {
            _this.hideOverlay();
        });
        this.transport.on(MagicIncomingWindowMessage.MAGIC_SHOW_OVERLAY, function () {
            _this.showOverlay();
        });
    };
    return ViewController;
}());
export { ViewController };
//# sourceMappingURL=view-controller.js.map